import { useEffect } from 'react';

import { useEncounterSessionStore } from '@/lib/stores/encounter-session-store';

export function RecordingGuard() {
  const status = useEncounterSessionStore((s) => s.recordingMeta.status);
  const isActive = status === 'recording' || status === 'paused' || status === 'interrupted';

  useEffect(() => {
    if (!isActive) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isActive]);

  return null;
}
